import { LoadDoctorSchedule } from 'domain/usecases/doctor/load-doctor-schedule'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadDoctorSchedule implements LoadDoctorSchedule {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(params?: LoadDoctorSchedule.Params): Promise<LoadDoctorSchedule.Model> {
    return this.doctorRepository.loadDoctorSchedule(params)
  }
}
